import moment from 'moment'
import React, { useState } from 'react'
import { Pie, Bar } from 'react-chartjs-2'
import { Card, Col, Row, Statistic } from 'antd'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, BarElement, Title } from 'chart.js'

import { AiOutlineArrowDown, AiOutlineArrowUp } from 'react-icons/ai'

import DateRangePicker from '../../../components/reusable/rangePicker'

ChartJS.register(ArcElement, CategoryScale, Tooltip, Legend, BarElement, Title, LinearScale)

const Visits = () => {
    const [range, setRange] = useState([moment().startOf('day'), moment().endOf('day')])

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top'
            },
            title: {
                display: true,
                text: 'Chart.js Bar Chart'
            }
        },
    }

    const options2 = {
        indexAxis: 'y',
        elements: {
            bar: {
                borderWidth: 2,
            }
        },
        responsive: true,
        plugins: {
            legend: {
                position: 'right',
            },
            title: {
                display: true,
                text: 'Chart.js Horizontal Bar Chart',
            }
        }
    }

    const pData = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19, 3, 5, 2, 3],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(255, 206, 86, 0.2)',
                    'rgba(75, 192, 192, 0.2)',
                    'rgba(153, 102, 255, 0.2)',
                    'rgba(255, 159, 64, 0.2)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)',
                ],
                borderWidth: 1,
            },
        ],
    }

    const gData = {
        labels: ['Male', 'Female'],
        datasets: [
            {
                label: '# of Votes',
                data: [12, 19],
                backgroundColor: [
                    'rgba(255, 99, 132, 0.2)',
                    'rgba(54, 162, 235, 0.2)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)'
                ],
                borderWidth: 1,
            },
        ],
    }

    const bData = {
        labels: ['< 5 years', '5 - 10 years', '10 - 18 years', '18 - 35 years', '> 35 years'],
        datasets: [
            {
                label: 'Male',
                data: [12, 19, 3, 5, 2],
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Female',
                data: [19, 3, 5, 2, 34],
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
            {
                label: 'Both',
                data: [31, 22, 8, 7, 36],
                backgroundColor: 'rgba(53, 132, 215, 0.5)',
            }
        ],
    }

    const hData = {
        labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
        datasets: [
            {
                label: 'Dataset 1',
                data: [12, 19, 3, 5, 2, 3],
                borderColor: 'rgb(255, 99, 132)',
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            }
        ],
    }

    return (
        <>
            <div className="sm:flex sm:justify-between sm:items-between mb-8">
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                </div>
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end items-center gap-2">
                    <DateRangePicker ranges={range} selectRange={setRange} showTime />
                </div>
            </div>
            <div className="col-span-full xl:col-span-8">
                <div className="flex py-10 font-semibold text-md justify-center">
                    <div className="w-1/3 mx-2">
                        <h2 className='text-xl font-semibold'>Visits By Status</h2>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Card bordered={false}>
                                    <Statistic
                                        title="New Visits"
                                        value={11.28}
                                        precision={2}
                                        valueStyle={{
                                            color: '#3f8600',
                                        }}
                                        prefix={<AiOutlineArrowDown />}
                                        suffix="%" />
                                </Card>
                            </Col>
                            <Col span={12}>
                                <Card bordered={false}>
                                    <Statistic
                                        title="Revisits"
                                        value={11.28}
                                        precision={2}
                                        valueStyle={{
                                            color: '#cf1322',
                                        }}
                                        prefix={<AiOutlineArrowUp />}
                                        suffix="%" />
                                </Card>
                            </Col>
                        </Row>
                    </div>
                    <Row className="w-1/3 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Visits By Clinic</h2>
                        <Pie data={pData} />
                    </Row>
                    <Row className="w-1/3 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Visits By Payment Method</h2>
                        <Pie data={pData} />
                    </Row>
                </div>
                <div className="flex py-10 font-semibold text-md justify-center">
                    <Row className="w-1/4 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Visits By Gender</h2>
                        <Pie data={gData} />
                    </Row>
                    <Row className="w-3/4 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Visits By Age Group</h2>
                        <Bar options={options} data={bData} />
                    </Row>
                </div>
                <div className="flex py-10 font-semibold text-md justify-center">
                    <Row className="w-1/3 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Backlog by Service Points</h2>
                        <Pie data={pData} />
                    </Row>
                    <Row className="w-1/3 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Clinic Turnaround Time</h2>
                        <Pie data={pData} />
                    </Row>
                    <Row className="w-1/3 mx-2 px-5" gutter={16}>
                        <h2 className='text-xl font-semibold'>Clinic Queue Waiting Period</h2>
                        <Bar options={options2} data={hData} />
                    </Row>
                </div>
            </div>
        </>
    )
}

export default Visits